import { Tab } from "@components/templates/Tab";
import { contactsTabDataHandler } from "@containers/AddressBook/utils/constant";
import { mainContactTabs } from "@containers/CompanyBookmark/utils/constant";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";

export const TabComponent = ({ setType }) => {
  const onClickHandler = (index) => {
    if (contactsTabDataHandler[index]?.value === mainContactTabs.company) {
      setType(mainContactTabs.company);
      trademoTrackingEvents(trackingEventDictionary.dashboardContactsListEmployeeContactsTab, generateTrackingObject("intel-logistics-favourite"));
    } else {
      setType(mainContactTabs.ai);
      trademoTrackingEvents(trackingEventDictionary.dashboardContactsListAIFetchedContactsTab, generateTrackingObject("intel-logistics-favourite"));
    }
  };
  return <Tab options={contactsTabDataHandler} onClick={onClickHandler} />;
};
